define( [
	"./document"
], function( document ) {
	return document.documentElement;
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/documentElement.js
 ** module id = 442
 ** module chunks = 2
 **/